import Image from 'next/image'
import React from 'react'
import SectionHeading from './../Common/SectionHeading'
import AccordionSection from '../Common/AccordionSection'
import { accordionList } from './data/ClientData'
export default function OurUsps({data}) {
  return (
    <>
    <div className="flex flex-col justify-center w-11/12 mx-auto my-4 xl:max-w-screen max-w-screen-2xl lg:my-8">
      
      
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-12 lg:col-span-6">
          <div className="lg:p-6 p-4 bg-[#031527] text-white rounded-xl rounded-br-[100px]">
            <SectionHeading
              title={data?.title}
              
            />
            <div className="grid grid-cols-12 gap-6">
              {data.usp_data?.map((item, index)=>(
                <div key={index} className='col-span-12 md:col-span-6'>
                    <div className="flex items-center">
                      <Image 
                        priority={false}
                        className="w-6 h-6 lg:h-8 lg:w-8"
                        width={2000}
                        height={2000}
                        src={process.env.IMG_CDN+item?.icon}
                        alt={item?.altText ? item?.altText : item?.title ? item?.title : 'DelveInsight'}
                      />
                      <h3 className="pl-4 text-lg font-semibold text-white">
                        {item?.title}
                      </h3>
                    </div>
                    <p className="my-2 text-base line-clamp-3">{item?.description}</p>
                </div>
              ))}
          </div>
          </div>
        </div>
        <div className="col-span-12 lg:col-span-6">
          <SectionHeading 
            title={data?.title_1}
            
          />
          <AccordionSection data={accordionList} />
        </div>
      </div>
    </div>
    </>
  )
}
